import { render } from "./LightboxItem360.vue?vue&type=template&id=1bd35a82&scoped=true"
import script from "./LightboxItem360.vue?vue&type=script&lang=ts"
export * from "./LightboxItem360.vue?vue&type=script&lang=ts"

import "./LightboxItem360.vue?vue&type=style&index=0&id=1bd35a82&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1bd35a82"

export default script